import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinthane() {



    const cardData = {




keyword: "Cab Service in Thane",

headingDescription: "Shreesha Tours & Travels provides reliable, comfortable, and affordable Cab Services in Thane for local travel, airport transfers, corporate transportation, railway station pickup, outstation trips, family vacations, and long-distance journeys across India. We offer one-way cabs, round-trip taxi services, chauffeur-driven cars, corporate cab solutions, and customized travel packages with a wide range of vehicles including Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars. With doorstep pickup across Thane, experienced drivers, well-maintained vehicles, transparent pricing, easy booking options, and 24/7 customer support, Shreesha Tours & Travels ensures a safe and hassle-free travel experience. Whether you need a taxi for business meetings, airport transfers, family outings, pilgrimage tours, weekend trips, or outstation travel from Thane to popular destinations across Maharashtra and India, our professional cab services provide punctuality, comfort, and reliable transportation.",

topPlaces: [
  {
    title: "Thane to Lonavala",
    description: "Lonavala is a popular hill station near Thane known for scenic valleys, waterfalls, Tiger Point, Bhushi Dam, Rajmachi Fort, and pleasant weather. It is a preferred destination for weekend trips, family vacations, and corporate outings."
  },
  {
    title: "Thane to Mumbai Airport",
    description: "Mumbai Airport is one of the busiest airports in India, and many travelers from Thane require comfortable airport transfers. Professional cab services provide timely pickup, flight tracking, and convenient travel between Thane and the airport."
  },
  {
    title: "Thane to Pune",
    description: "Pune is a major IT, educational, and business hub with destinations like Hinjawadi, Kharadi, Magarpatta, and Baner. Thane to Pune cab services are widely used by corporate professionals, students, and families."
  },
  {
    title: "Thane to Shirdi",
    description: "Shirdi is a famous pilgrimage destination dedicated to Sai Baba. Devotees from Thane regularly book cabs for comfortable religious journeys with family members and senior citizens."
  },
  {
    title: "Thane to Nashik",
    description: "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, temples, and scenic attractions. It is a popular route for religious tours, corporate visits, and weekend getaways."
  },
  {
    title: "Thane to Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station famous for viewpoints, strawberry farms, lakes, and waterfalls. Cab services from Thane provide a comfortable travel option for families and couples."
  },
  {
    title: "Thane to Goa",
    description: "Goa is one of India's most popular holiday destinations, offering beaches, resorts, churches, forts, and water activities. Long-distance cab services from Thane provide a convenient road travel experience."
  },
  {
    title: "Thane to Alibaug",
    description: "Alibaug is a coastal getaway near Mumbai known for beaches, forts, resorts, and peaceful surroundings. It is ideal for weekend holidays, family trips, and short vacations from Thane."
  },
  {
    title: "Thane to Surat",
    description: "Surat is a major commercial city famous for diamond and textile industries. Business travelers frequently use Thane to Surat cab services for meetings, industrial visits, and corporate travel."
  },
  {
    title: "Thane to Ahmedabad",
    description: "Ahmedabad is Gujarat's leading business and cultural city with corporate offices, industries, and heritage attractions. Cab services from Thane provide comfortable transportation for business and leisure travelers."
  }
],



"services": [
  {
    "name": "Cab Service in Thane",
    "description": "Book Cab Service in Thane for safe, comfortable, and reliable transportation with professional chauffeurs and well-maintained AC vehicles. Get Sedan, Ertiga, Innova Crysta, SUV, and premium cab options for local travel, airport transfers, outstation trips, family journeys, and corporate transportation needs."
  },
  {
    "name": "Taxi Service in Thane",
    "description": "Choose Taxi Service in Thane for affordable and convenient travel with experienced drivers, clean vehicles, and flexible booking options. Enjoy smooth transportation for daily travel, business trips, sightseeing, airport transfers, and long-distance journeys."
  },
  {
    "name": "Thane Cab Booking",
    "description": "Complete Thane Cab Booking online with quick confirmation, multiple vehicle options, and reliable chauffeur services. Select comfortable cabs according to your travel requirements for local rides, outstation journeys, family trips, and corporate travel."
  },
  {
    "name": "Thane Taxi Service",
    "description": "Hire Thane Taxi Service for professional and dependable transportation with transparent pricing and well-maintained vehicles. Travel comfortably across Thane, Mumbai, nearby cities, and outstation destinations with experienced drivers."
  },
  {
    "name": "Best Cab Service Thane",
    "description": "Choose the Best Cab Service Thane for premium travel experience with trained chauffeurs, affordable fares, and quality vehicles. Get reliable cab solutions for airport pickup, business travel, family trips, and personal transportation."
  },
  {
    "name": "Thane Car Rental Service",
    "description": "Book Thane Car Rental Service for chauffeur-driven vehicles with flexible rental packages and comfortable travel options. Choose from Sedan, SUV, Innova Crysta, and luxury cars for local sightseeing, corporate travel, events, and outstation trips."
  },
  {
    "name": "Thane Outstation Cab",
    "description": "Hire Thane Outstation Cab for safe and comfortable long-distance travel with professional drivers and AC vehicles. Enjoy reliable one way and round trip cab services from Thane to destinations across Maharashtra and India."
  },
  {
    "name": "Thane Airport Taxi Service",
    "description": "Book Thane Airport Taxi Service for timely airport pickup and drop facilities with comfortable vehicles and experienced chauffeurs. Enjoy hassle-free airport transfers from Thane to Mumbai Airport with 24x7 cab availability."
  },
  {
    "name": "Thane One Way Cab",
    "description": "Choose Thane One Way Cab for affordable single-direction travel without return charges. Get fixed pricing, clean vehicles, professional drivers, and convenient pickup options for outstation and city-to-city journeys."
  },
  {
    "name": "Thane Round Trip Taxi",
    "description": "Reserve Thane Round Trip Taxi for comfortable return journeys with flexible travel schedules and affordable packages. Perfect for family vacations, weekend trips, sightseeing tours, business visits, and personal travel requirements."
  },
  {
    "name": "Thane Corporate Cab Service",
    "description": "Select Thane Corporate Cab Service for reliable employee transportation, business travel, airport transfers, and office commute solutions. Get punctual service with professional chauffeurs and well-maintained vehicles for corporate requirements."
  },
  {
    "name": "Thane Local Taxi Service",
    "description": "Book Thane Local Taxi Service for quick and convenient city transportation with experienced drivers and comfortable cars. Ideal for daily travel, shopping trips, meetings, station transfers, and local sightseeing."
  },
  {
    "name": "Thane 24x7 Cab Service",
    "description": "Get Thane 24x7 Cab Service for round-the-clock transportation support with reliable vehicles and professional drivers. Enjoy anytime booking facilities for airport transfers, emergency travel, local rides, and outstation journeys."
  }
],
"tableData": [
  ["Cab Service in Thane", "Taxi Service in Thane"],
  ["Thane Cab Booking", "Thane Taxi Service"],
  ["Best Cab Service Thane", "Thane Car Rental Service"],
  ["Thane Outstation Cab", "Thane Airport Taxi Service"],
  ["Thane One Way Cab", "Thane Round Trip Taxi"],
  ["Thane Corporate Cab Service", "Thane Local Taxi Service"],
  ["Thane 24x7 Cab Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Thane for Every Journey",
    WhyChoosedescription: "Shreesha Tours & Travels provides comfortable and dependable cab services in Thane for local travel, airport transfers, corporate transportation, sightseeing, family trips, and outstation journeys with professional drivers and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Complete Local & Outstation Travel Solutions",
    WhyChoosedescription: "Whether you need a quick city ride, Mumbai Airport transfer, business travel, weekend getaway, or long-distance taxi service, our Thane cab solutions are designed for every type of traveller."
  },
  {
    WhyChooseheading: "Wide Selection of Comfortable Vehicles",
    WhyChoosedescription: "Choose from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses according to your passenger count and travel needs."
  },
  {
    WhyChooseheading: "Airport Taxi Service from Thane",
    WhyChoosedescription: "Get timely airport pickup and drop facilities from Thane to Mumbai Airport with experienced drivers who understand city traffic and provide smooth transfers."
  },
  {
    WhyChooseheading: "Corporate Cab Services for Businesses",
    WhyChoosedescription: "Our corporate taxi solutions support employee transportation, office travel, client meetings, business events, and executive movement across Thane and nearby business hubs."
  },
  {
    WhyChooseheading: "Experienced Drivers with Route Knowledge",
    WhyChoosedescription: "Our professional chauffeurs are familiar with Thane, Mumbai, Navi Mumbai, highways, and popular destinations, ensuring safe and comfortable travel."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Rental Options",
    WhyChoosedescription: "Book one-way taxis, round trip cabs, hourly rentals, full-day packages, sightseeing tours, and customized travel plans based on your schedule."
  },
  {
    WhyChooseheading: "Trusted Taxi Partner in Thane",
    WhyChoosedescription: "Shreesha Tours & Travels focuses on punctual service, transparent pricing, clean vehicles, and customer satisfaction to deliver a reliable cab experience."
  }
]

};

const faqData = [
  {
    question: "What cab services are available in Thane?",
    answer: "We provide local taxi services, airport transfers, outstation cabs, corporate travel, sightseeing tours, wedding transportation, and car rental services in Thane."
  },
  {
    question: "Can I book a cab from Thane to Mumbai Airport?",
    answer: "Yes, airport pickup and drop services are available from all major areas of Thane to Mumbai Airport."
  },
  {
    question: "Which cars are available for Cab Service in Thane?",
    answer: "You can book Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses."
  },
  {
    question: "Do you provide outstation cabs from Thane?",
    answer: "Yes, we offer one-way and round-trip taxi services from Thane to destinations across Maharashtra and other states."
  },
  {
    question: "Can I hire a cab in Thane for corporate travel?",
    answer: "Yes, corporate cab services are available for employee transportation, meetings, conferences, and business travel."
  },
  {
    question: "Is cab booking available from Thane railway station?",
    answer: "Yes, pickup and drop services are available from Thane Railway Station, residential areas, offices, hotels, and other locations."
  },
  {
    question: "Can I book a Tempo Traveller for group travel from Thane?",
    answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, corporate outings, school trips, and group journeys."
  },
  {
    question: "Do you provide sightseeing cabs in and around Thane?",
    answer: "Yes, sightseeing and customized tour packages are available for Thane, Mumbai, nearby hill stations, and tourist destinations."
  },
  {
    question: "How is the Thane cab fare calculated?",
    answer: "The fare depends on the vehicle type, distance, trip duration, route, and selected service option such as one-way, round trip, or rental."
  },
  {
    question: "How can I book Cab Service in Thane with Shreesha Tours & Travels?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Kulkarni",
    feedback: "I booked a cab from Thane for Mumbai Airport travel. The driver arrived on time, the vehicle was clean, and the complete journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Shah",
    feedback: "Our family hired an Innova for an outstation trip from Thane. The booking process was simple, the driver was professional, and the travel experience was excellent.",
    rating: 5
  }
];















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Thane",
  "image": "https://www.shreeshatravels.com/assets/images/cab-service-in-thane.webp",
  "description":
    "Book Cab Service in Thane with Shreesha Tours & Travels for safe, comfortable, and affordable local and outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, corporate travel, business meetings, family trips, local sightseeing, and intercity journeys with professional chauffeurs.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/cab-service-in-thane"
  }
};






    return (
        <div>
<Helmet>
  <title>Cab Service in Thane | 24x7 Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Cab Service in Thane with Shreesha Travels for reliable local, airport, and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with professional drivers, affordable fares, and 24x7 online booking."
  />

  <meta
    name="keywords"
    content="Cab Service in Thane, Taxi Service in Thane, Thane Cab Booking, Thane Taxi Service, Best Cab Service in Thane, Online Cab Booking Thane, Thane Airport Cab Service, Thane Outstation Cab, Thane Car Rental with Driver, Thane Taxi Booking, Thane One Way Cab, Thane Round Trip Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinthane;